var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClinicForm',{ref:"updateClinicForm",attrs:{"id":"update-clinic","title":_vm.$i18n.t('lb_update_clinic'),"clinic":_vm.getClinic,"isLoading":_vm.isLoading},on:{"handleOk":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }